import { required, SelectInput } from "react-admin";
import { subcontractorHolidayPaymentRouteTypeList } from "../const";

interface ISubcontractorHolidayPaymentRouteTypeInput {
  callback?: (x: string) => void;
}

const SubcontractorHolidayPaymentRouteTypeInput = (
  props: ISubcontractorHolidayPaymentRouteTypeInput,
) => {
  return (
    <SelectInput
      source="routeType"
      label="RouteType"
      choices={subcontractorHolidayPaymentRouteTypeList}
      validate={required()}
      onChange={({ target }) => {
        props.callback && props.callback(target.value);
      }}
    />
  );
};

export default SubcontractorHolidayPaymentRouteTypeInput;
